import App from './App';
import { withRouter } from 'react-router'

export default withRouter(App);


// WEBPACK FOOTER //
// ./src/components/AppContainer.js